export function getFileExtension(fileName) {
  return fileName.substring(fileName.lastIndexOf('.'));
}
